// Selects mock vs. real HTTP API based on VITE_USE_MOCK_API.
// Default = real backend (mock only when VITE_USE_MOCK_API=true).
// To use the in-app mock: set VITE_USE_MOCK_API=true.

import type { PatientApi } from '../types/patient.types';
import { patientHttpApi } from './patient.api';
import { patientMockApi } from './patient.mock';

const useMock = import.meta.env.VITE_USE_MOCK_API === 'true';

export const patientApi: PatientApi = useMock ? patientMockApi : patientHttpApi;
